const prices = {
  A: [
    {
      title: { up: "30Mbps", down: "15Mbps" },
      price: { value: { normal: "RD$0.00", offert: "RD$0.00" }, type: "mensual" },
      specifications: ["30Mbps de bajada", "15Mbps de subida", "Transferencia ilimitada"],
    },
    {
      title: { up: "50Mbps", down: "25Mbps" },
      price: { value: { normal: "RD$0.00", offert: "RD$0.00" }, type: "mensual" },
      specifications: ["50Mbps de bajada", "25Mbps de subida", "Transferencia ilimitada"],
    },
    {
      title: { up: "100Mbps", down: "50Mbps" },
      price: { value: { normal: "RD$0.00", offert: "RD$0.00" }, type: "mensual" },
      specifications: ["100Mbps de bajada", "50Mbps de subida", "Transferencia ilimitada"],
    },
    {
      title: { up: "150Mbps", down: "75Mbps" },
      price: { value: { normal: "RD$0.00", offert: "RD$0.00" }, type: "mensual" },
      specifications: ["150Mbps de bajada", "75Mbps de subida", "Transferencia ilimitada"],
    },
  ],
};

export default prices;
